module.exports = __webpack_public_path__ + "static/open_brochure-c36dd927758c3b0d18ec20ea2ed70c5b.png";